import React, { Component } from 'react';
import { connect } from 'react-redux';
import './chart.css';
import {lowestDenom} from '../../../../config';

class Depth extends Component {
  createChart(chartName,chartData) {

    function balloon(item, graph) {
      var txt;
      if (graph.id == "asks") {
        txt = "Ask: <strong>" + formatNumber(item.dataContext.value, graph.chart, 4) + "</strong><br />"
          + "Total volume: <strong>" + formatNumber(item.dataContext.askstotalvolume, graph.chart, 4) + "</strong><br />"
          + "Volume: <strong>" + formatNumber(item.dataContext.asksvolume, graph.chart, 4) + "</strong>";
      }
      else {
        txt = "Bid: <strong>" + formatNumber(item.dataContext.value, graph.chart, 4) + "</strong><br />"
          + "Total volume: <strong>" + formatNumber(item.dataContext.bidstotalvolume, graph.chart, 4) + "</strong><br />"
          + "Volume: <strong>" + formatNumber(item.dataContext.bidsvolume, graph.chart, 4) + "</strong>";
      }
      return txt;
    }

    function formatNumber(val, chart, precision) {
      return window.AmCharts.formatNumber(
        val,
        {
          precision: precision ? precision : chart.precision,
          decimalSeparator: chart.decimalSeparator,
          thousandsSeparator: chart.thousandsSeparator
        }
      );
    }

    this.chart = window.AmCharts.makeChart(chartName, {
      "type": "serial",
      "theme": "dark",
      "dataProvider": chartData,
      "graphs": [{
        "id": "bids",
        "fillAlphas": 0.1,
        "lineAlpha": 1,
        "lineThickness": 2,
        "lineColor": "#0f0",
        "type": "step",
        "valueField": "bidstotalvolume",
        "balloonFunction": balloon
      }, {
        "id": "asks",
        "fillAlphas": 0.1,
        "lineAlpha": 1,
        "lineThickness": 2,
        "lineColor": "#f00",
        "type": "step",
        "valueField": "askstotalvolume",
        "balloonFunction": balloon
      }, {
        "lineAlpha": 0,
        "fillAlphas": 0.2,
        "lineColor": "#000",
        "type": "column",
        "clustered": false,
        "valueField": "bidsvolume",
        "showBalloon": false
      }, {
        "lineAlpha": 0,
        "fillAlphas": 0.2,
        "lineColor": "#000",
        "type": "column",
        "clustered": false,
        "valueField": "asksvolume",
        "showBalloon": false
      }],
      "categoryField": "value",
      "chartCursor": {},
      "balloon": {
        "textAlign": "left"
      },
      "valueAxes": [{
        // "title": "Volume"
      }],
      "categoryAxis": {
        "startOnAxis": true,
        "minHorizontalGap": 100,
        "showFirstLabel": false,
        "showLastLabel": false
      },
      "balloon": {
        "textAlign": "left"
      },
      "export": {
        "enabled": false
      }
    });

  }
  processData(list, type, desc,res) {

    // Convert to data points
    for(let i = 0; i < list.length; i++) {
      list[i] = {
        value: Number(list[i].price),
        volume: Number(list[i].total),
      }
    }

    // Sort list just in case
    list.sort(function(a, b) {
      if (a.value > b.value) {
        return 1;
      }
      else if (a.value < b.value) {
        return -1;
      }
      else {
        return 0;
      }
    });

    // Calculate cummulative volume
    if (desc) {
      for(let i = list.length - 1; i >= 0; i--) {
        if (i < (list.length - 1)) {
          list[i].totalvolume = list[i+1].totalvolume + list[i].volume;
        }
        else {
          list[i].totalvolume = list[i].volume;
        }
        let dp = {};
        dp["value"] = list[i].value;
        dp[type + "volume"] = list[i].volume;
        dp[type + "totalvolume"] = list[i].totalvolume;
        res.unshift(dp);
      }
    }
    else {
      for(let i = 0; i < list.length; i++) {
        if (i > 0) {
          list[i].totalvolume = list[i-1].totalvolume + list[i].volume;
        }
        else {
          list[i].totalvolume = list[i].volume;
        }
        let dp = {};
        dp["value"] = list[i].value;
        dp[type + "volume"] = list[i].volume;
        dp[type + "totalvolume"] = list[i].totalvolume;
        res.push(dp);
      }
    }
  }
  toChartData({arr,type}){
    return this.combine(arr).map(offer => {
      return {
        type,
        total:offer.amount,
        price:offer.price
      }
    });
  }
  combine(arr){
    let hash = {};
    arr.forEach((a)=>{
      if(hash[a.price]) hash[a.price] = hash[a.price] + parseFloat(a.price*a.amount);
      else hash[a.price] = parseFloat(a.price*a.amount);
    })

    let orders = [];
    Object.keys(hash).forEach((price)=>{
      if(arr.length > 0){
        orders.push({price,amount:hash[price]});
      }
    })
    return orders;
  }
  parseData(){

    let d = this.toChartData({arr:this.props.offers,type:'ask'});
    let o = this.toChartData({arr:this.props.demand,type:'bid'});
    let chartData = [];

    let processData = this.processData;

    processData(o, "bids", true,chartData);
    processData(d, "asks", false,chartData);

    return chartData;
  }
  initiateChart(){

    let data = this.parseData();

    this.createChart('chartdiv',data);
  }
  updateChart(){
    let data = this.parseData();
    if(data !== this.chart.dataProvider){
      this.chart.dataProvider = data;
      this.chart.validateData();
    }
  }
  componentDidUpdate(){
    this.updateChart();
  }
  componentDidMount(){
    this.initiateChart();
    let element = document.getElementById('chartdiv');
    if(element) element.classList.remove("fadein");
    if(element) void element.offsetWidth;
    if(element) element.classList.add("fadein");
  }
  render() {
    let display = this.props.offers.length > 0 || this.props.demand.length > 0 ? '' : 'none';
    return (
      <div className="row" >
        <div style={{display}}>
          <div className='depthdiv' id="chartdiv">
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state,props) {
  return {
    offers:state.orderbook.offers,
    demand:state.orderbook.demand
  };
}

export default connect(mapStateToProps,{})(Depth);
